import axios from 'axios';

export default {
  logIn(email, password) {
    return axios({
      method: 'post',
      url: 'oauth/token',
      baseURL: process.env.MIX_ZDM_API_HOST,
      data: {
        grant_type: 'password',
        client_id: 1,
        client_secret: process.env.MIX_ZDM_API_CLIENT_SECRET,
        username: email,
        password,
        scope: null,
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return false;
      });
  },
  logOut() {
    return axios
      .get('/logout')
      .then((response) => {
        return response.data;
      })
      .catch((error) => alert(error));
  },
  register(data) {
    return axios
      .post('/register', data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => alert(error));
  },
  recoverPassword(email) {
    return axios.post(`forgot-password`, {
      email,
      hostname: `${window.location.protocol}//${window.location.hostname}`,
    });
  },
  resetPassword(token, email, password, passwordConfirm) {
    return axios
      .post('reset-password', {
        token,
        email,
        password,
        password_confirmation: passwordConfirm,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.response.data;
      });
  },
  getAccount() {
    const appends = [
      'brandIds',
      'fulfillmentCenterIds',
      'facilityIds',
      'organizationIds',
    ];

    return axios.get(`profile?appends=${appends.join(',')}`).catch(() => {
      return false;
    });
  },
  updateAccount(data) {
    return axios.post('profile', data);
  },
  changePassword(data) {
    return axios.post('profile/password', data);
  },
};
